{
  "booking.reserve": "Réserver",
  "booking.title": "Réserver une table",
  "common.close": "Fermer",
  "common.retry": "Réessayer",
  "common.loading": "Chargement",
  "common.loadingEllipsis": "Chargement…",
  "common.pageLoading": "Chargement de la page",
  "booking.loading": "Chargement des disponibilités…",
  "booking.unavailable": "La réservation en ligne ne répond pas pour le moment.",
  "booking.slow": "Cela prend un peu plus de temps. Vous pouvez aussi appeler le restaurant.",
  "booking.call": "Appeler le restaurant",
  "nav.home": "Accueil de notre site",
  "nav.main": "Navigation principale",
  "nav.mobile": "Navigation mobile",
  "nav.menu": "Cartes & Menus",
  "nav.photos": "Photos",
  "nav.contact": "Accès / Contact",
  "nav.close": "Fermer le menu",
  "nav.open": "Ouvrir le menu",
  "legal.title": "Mentions légales",
  "privacy.title": "Politique de confidentialité",
  "home.restaurant": "Notre restaurant",
  "home.discover": "Découvrir nos cartes",
  "hours.title": "Horaires",
  "hours.open": "Ouvert",
  "hours.closed": "Fermé",
  "hours.today": "aujourd’hui",
  "newsletter.subscribe": "S'inscrire",
  "newsletter.thanks": "Merci !",
  "newsletter.email": "Votre adresse email",
  "newsletter.placeholder": "Renseignez votre adresse email",
  "menu.bodeguita": "Carte Bodeguita",
  "menu.restaurant": "Carte du Restaurant",
  "gallery.cover": "Terrasse du Bouddoir le soir, sous les guirlandes lumineuses",
  "gallery.title": "Nos photos",
  "gallery.label": "Galerie photos",
  "gallery.close": "Fermer la galerie",
  "gallery.previous": "Photo précédente",
  "gallery.next": "Photo suivante",
  "gallery.error": "Cette photo n’a pas pu être chargée.",
  "gallery.unavailable": "Photo indisponible",
  "common.pageError": "Cette page n’a pas pu être chargée.",
  "notFound.title": "Page introuvable",
  "notFound.description": "La page que vous cherchez n’existe pas ou a été déplacée.",
  "notFound.home": "Retour à l’accueil",
  "common.backTop": "Retour en haut de page",
  "legal.updated": "Dernière mise à jour :",
  "legal.intro": "Conformément à l’article 6-III de la loi n°2004-575 du 21 juin 2004 pour la confiance dans l’économie numérique, les informations suivantes identifient l’éditeur et l’hébergeur du site",
  "legal.publisher": "Éditeur du site",
  "legal.operator": "Exploitant le restaurant",
  "legal.address": "Siège social :",
  "legal.siret": "SIRET de l’établissement :",
  "legal.phone": "Téléphone :",
  "legal.capital": "Capital social",
  "legal.vat": "Numéro de TVA intracommunautaire",
  "legal.email": "Courriel",
  "legal.director": "Directeur de la publication",
  "legal.host": "Hébergeur",
  "legal.ipTitle": "Propriété intellectuelle",
  "legal.ip": "Les textes, photographies, logos et éléments graphiques de ce site sont protégés par le droit d’auteur. Toute reproduction ou représentation, totale ou partielle, sur quelque support que ce soit, est soumise à l’autorisation écrite préalable de",
  "legal.linksTitle": "Liens vers d’autres sites",
  "legal.links": "Ce site renvoie vers des sites tiers — réseaux sociaux, cartographie — dont le contenu ne dépend pas de",
  "legal.linksEnd": ", qui ne peut donc en répondre.",
  "legal.liabilityTitle": "Responsabilité",
  "legal.liability": "Les informations publiées sur ce site, en particulier les horaires, la carte et les tarifs, sont données à titre indicatif et peuvent évoluer. Seul le restaurant, joignable au",
  "legal.liabilityEnd": ", fait foi.",
  "legal.dataTitle": "Données personnelles",
  "legal.data": "Le traitement des données personnelles, la réservation en ligne et l’absence de cookies sont décrits dans la",
  "legal.privacyLink": "politique de confidentialité",
  "legal.lawTitle": "Droit applicable",
  "legal.law": "Les présentes mentions légales sont soumises au droit français. Les tribunaux français sont seuls compétents.",
  "privacy.intro": "Cette page explique ce que la consultation de",
  "privacy.introEnd": "collecte, et où trouver le détail du traitement lié à une réservation.",
  "privacy.controllerTitle": "Article 1 : Qui traite vos données",
  "privacy.controller": "Le responsable du traitement est",
  "privacy.registration": ", immatriculé sous le numéro SIREN",
  "privacy.address": ", dont le siège est situé",
  "privacy.contact": "Vous pouvez le joindre par téléphone au",
  "privacy.email": ", par courriel à",
  "privacy.contactEnd": ", ou par courrier à l’adresse ci-dessus.",
  "privacy.visitingTitle": "Article 2 : La consultation de ce site",
  "privacy.visiting": "Consulter ces pages ne donne lieu à",
  "privacy.noCollection": "aucune collecte",
  "privacy.noCollectionEnd": ": pas de compte, pas de formulaire, pas de mesure d’audience.",
  "privacy.noCookies": "Ce site ne dépose aucun cookie",
  "privacy.noCookiesEnd": "et n’utilise aucun traceur publicitaire. Aucun bandeau de consentement n’est donc nécessaire.",
  "privacy.thirdParties": "Trois services tiers sont appelés pour afficher les pages, et reçoivent de ce fait votre adresse IP : Google Fonts (",
  "common.and": "et",
  "privacy.fonts": ") pour les polices de caractères, et jsDelivr (",
  "privacy.styles": ") pour la feuille de style. Ils ne déposent pas de cookie sur ce site.",
  "privacy.bookingTitle": "Article 3 : La réservation en ligne",
  "privacy.booking": "La réservation en ligne, lorsqu’elle est proposée sur ce site, est assurée par un service dédié qui recueille vos coordonnées pour le compte du restaurant. Les données collectées, leur finalité, leur durée de conservation et les prestataires qui interviennent y sont décrits dans une notice propre à ce restaurant :",
  "privacy.bookingLink": "Confidentialité de la réservation en ligne",
  "privacy.bookingNotice": "Cette notice est également accessible depuis le formulaire de réservation lui-même. Elle fait autorité pour tout ce qui concerne une réservation : la présente page ne la répète pas, afin qu’il n’existe qu’une seule version de ces informations.",
  "privacy.rightsTitle": "Article 4 : Vos droits",
  "privacy.rights": "Vous disposez d’un droit d’accès, de rectification, d’effacement, de limitation et d’opposition sur les données qui vous concernent, ainsi que d’un droit à la portabilité. Vous les exercez auprès du restaurant, par les moyens indiqués à l’article 1, en justifiant de votre identité. Une réponse vous est apportée dans un délai d’un mois.",
  "privacy.complaint": "Si vous estimez que vos droits ne sont pas respectés, vous pouvez saisir la Commission nationale de l’informatique et des libertés (CNIL), 3 place de Fontenoy, 75007 Paris.",
  "privacy.changesTitle": "Article 5 : Modifications",
  "privacy.changes": "Cette politique peut être modifiée pour tenir compte d’une évolution du site ou de la réglementation. La date de dernière mise à jour figure en tête de page. L’identité de l’éditeur et de l’hébergeur est précisée dans les",
  "privacy.legalLink": "mentions légales",
  "menu.title": "Carte & menus",
  "menu.pdfFrench": "PDF en français · nouvel onglet",
  "gallery.open": "Ouvrir la photo {{number}}",
  "gallery.photo": "Photo {{number}} de notre restaurant",
  "hours.closes": "ferme à {{time}}",
  "hours.opens": "ouvre {{day}}à {{time}}",
  "legal.operating": "exploitant le restaurant",
  "menu.homemade": "Notre cuisine est maison, élaborée à partir de produits de qualité.",
  "nav.skip": "Aller au contenu",
  "newsletter.title": "Newsletter",
  "home.slideshow": "Diaporama de photos du restaurant et des plats",
  "home.slideshowList": "Photos du restaurant",
  "home.slidePosition": "Photo {{number}} sur {{total}}",
  "aboutUsEtablishmentTextFirstParagraph": "Découvrez l'enchantement sud-américain au Bouddoir, notre restaurant au cœur d'Aix-en-Provence, situé en face de l'emblématique fontaine d'Altius.",
  "aboutUsEtablishmentTextSecondParagraph": "Fusionnant les saveurs d'Amérique du Sud avec l'élégance provençale, notre restaurant original et authentique vous transporte dans un voyage gustatif unique.",
  "tapasTitle": "La Bodeguita",
  "tapasTextFirstPar": "Découvrez un voyage sensoriel en Amérique du Sud avec notre coin tapas. Des saveurs exotiques, des épices enivrantes, et une ambiance chaleureuse.",
  "tapasSecondPar": "Plus qu'un restaurant, Le Bouddoir est une expérience culinaire unique à Aix-en-Provence. Notre chef talentueux vous propose des tapas raffinés mettant en valeur les produits locaux de la Provence.",
  "descriptionCouverture": " Brunch / Tapas / Restaurant",
  "newsletterReserveTitle": "On vous attend ...",
  "newsletterReserveText": "Nous serons ravis de vous accueillir dans notre restaurant pour vous faire découvrir nos spécialités.",
  "newsletterText": "Restez informé avec notre newsletter et ne manquez aucune offre spéciale ni événement.",
  "cardTextFirst": "Explorez notre éventail gastronomique, alliant authenticité sud-américaine et provençale.",
  "cardTextSecond": "Au Bouddoir d'Aix-en-Provence, nous créons avec passion des expériences culinaires qui émerveillent vos sens.",
  "infoPracticeTitle": "Infos pratiques",
  "infoPracticePayment": "Règlements par CB / Espèces",
  "infoPracticeTicket": "Ticket resto uniquement le midi, du lundi au vendredi. La maison n’accepte pas les chèques.",
  "infoPracticePrices": "Prix nets TTC - Service compris",
  "altCouverture": "Salle de La Bodeguita au Bouddoir : enseigne au néon, fresque murale et banquettes vertes",
  "altAboutUs": "Salle du Bouddoir dressée pour le service, en lumière du jour",
  "altTapas": "Assortiment de tapas frits servi sur une planche",
  "altCardSection": "Entrecôte grillée dressée à l'assiette avec ses légumes",
  "altInfoPractice": "Tireuses à bière du bar du Bouddoir",
  "altCardMenuCover": "Pièce de bœuf saisie sur la braise du grill",
  "legalCompanyForm": "société par actions simplifiée (SAS)",
  "legalHostCountry": "États-Unis",
  "servesCuisine": [
    "Tapas",
    "Cuisine sud-américaine",
    "Brunch",
    "Cocktails"
  ]
}
